import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ClearButtonConfig } from "../types";

interface ClearButtonProps {
  onClick: () => void;
  config: ClearButtonConfig;
  disabled?: boolean;
}

export function ClearButton({ onClick, config, disabled }: ClearButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={onClick}
      disabled={disabled}
      aria-label={config.ariaLabel || "Clear search"}
      className="shrink-0"
    >
      {config.icon || <X className="h-4 w-4" />}
    </Button>
  );
}

